module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#photo",
      toString: function () {
        return this.url;
      }
    }